import { render, staticRenderFns } from "./SectionInefop.vue?vue&type=template&id=fc6bc4c2&scoped=true"
import script from "./SectionInefop.vue?vue&type=script&lang=js"
export * from "./SectionInefop.vue?vue&type=script&lang=js"
import style0 from "./SectionInefop.vue?vue&type=style&index=0&id=fc6bc4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6bc4c2",
  null
  
)

export default component.exports